export default {
  get(key, value = null) {
    if (localStorage.getItem(key) == null) {
      return value;
    }
    return localStorage.getItem(key);
  },

  set(key, value) {
    window.localStorage.setItem(key, value);
  },

  remove(key) {
    window.localStorage.removeItem(key);
  },

  clear() {
    window.localStorage.clear();
  }
};
